module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isIntalentModule) ? _c('Smart', {
    attrs: {
      "id": _vm.id,
      "age": _vm.age,
      "municipalityId": _vm.municipalityId,
      "name": _vm.name,
      "initTestResult": _vm.testResult
    }
  }) : _c('Warning', [_c('p', [_vm._v("Модуль отключен")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2b49512","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/career-guidance/CareerGuidance.vue
// module id = 6d0520b7fb3be0880266
// module chunks = 4